import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { BlankComponent } from './main/pages/blank/blank.component';
import { OrganizationAddComponent } from './main/pages/organization-add/organization-add.component';
import { AgencyAddComponent } from './main/pages/agency-add/agency-add.component';
import { MainComponent } from './main/main.component';
import { OrganizationListComponent } from './main/pages/organization-list/organization-list.component';
import { OrganizationDetailComponent } from './main/pages/organization-detail/organization-detail.component';
import { OrganizationResolverService } from './main/pages/organization-detail/resolvers/organization-resolver.service';
import { OrganizationAgencyResolverService } from './main/pages/organization-detail/resolvers/organization-agency-resolver.service';
import { OrganizationParameterComponent } from './main/frames/organization-parameter/organization-parameter.component';
import { CreditCardComponent } from './main/frames/credit-card/credit-card.component';
import { CrossParametersComponent } from './main/frames/cross-parameters/cross-parameters.component';
import { DepositComponent } from './main/frames/deposit/deposit.component';
import { DepositResolverService } from './main/frames/deposit/resolver/deposit-resolver.service';
import { ProviderResolverService } from './main/frames/resolvers/provider-resolver.service';
import { DomainsComponent } from './main/frames/domains/domains.component';
import { ParentAgencyComponent } from './main/frames/parent-agency/parent-agency.component';
import { AuthUserGuardService } from './utils/services/guards/auth-user-guard.service';
import { UserRoleGuardService } from './utils/services/guards/user-role-guard.service';
import { CrossParameterResolverService } from './main/frames/cross-parameters/resolver/cross-parameter-resolver.service';
import { ProviderCharacteristicResolverService } from './main/pages/provider-characteristic/resolver/provider-characteristic-resolver.service';
import { ProviderCharacteristicComponent } from './main/pages/provider-characteristic/provider-characteristic.component';
import { SystemHotelsComponent } from './main/pages/system-hotels/system-hotels.component';
import { SystemHotelRequestsComponent } from './main/pages/system-hotel-requests/system-hotel-requests.component';
import { HotelDetailComponent } from './main/pages/hotel-detail/hotel-detail.component';
import { AgencyProvidersComponent } from './main/frames/agency-providers/agency-providers.component';
import { ParameterResolverService } from './main/frames/resolvers/parameter-resolver.service';
import { HotelRegisterRequestsComponent } from './main/pages/hotel-register-requests/hotel-register-requests.component';
import { FreeHotelChangesComponent } from './main/pages/free-hotel-changes/free-hotel-changes.component';
import { RoomChangesComponent } from './main/pages/room-changes/room-changes.component';
import { ImageChangesComponent } from './main/pages/image-changes/image-changes.component';
import { HotelChangesItemComponent } from './main/pages/free-hotel-changes/hotel-changes-item/hotel-changes-item.component';
import { UsersComponent } from './main/frames/users/users.component';
import { BankBinNumbersComponent } from './main/pages/bank-bin-numbers/bank-bin-numbers.component';
import {TvLoginComponent} from './main/frames/tv-login/tv-login.component';
import { KvkkComponent } from './main/frames/kvkk/kvkk.component';

const APP_ROUTES: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthUserGuardService],
    canActivateChild: [AuthUserGuardService],
    children: [
      {
        path: 'dashboard',
        component: BlankComponent
      },
      {
        path: 'admin',
        canActivate: [UserRoleGuardService],
        canActivateChild: [UserRoleGuardService],
        data: {
          allowedRoles: ['Admin']
        },
        children: [
          {
            path: 'organizations',
            component: OrganizationListComponent,
            data: {
              viewType: 'ORGANIZATION',
            }
          },
          {
            path: 'organizations/new',
            component: OrganizationAddComponent
          },
          {
            path: 'organizations/:id',
            component: OrganizationDetailComponent,
            runGuardsAndResolvers: 'always',
            resolve: {
              organizationData: OrganizationResolverService,
              organizationAgencyData: OrganizationAgencyResolverService,
            },
            data: {
              viewType: 'ORGANIZATION'
            },
            children: [
              {
                path: 'parameter',
                component: OrganizationParameterComponent,
                resolve: {organizationParameters: ParameterResolverService}

              },
              {
                path: 'cross-parameters/:agencyID/:crossID',
                component: CrossParametersComponent,
                runGuardsAndResolvers: 'always',
                resolve: {
                  crossParameters: CrossParameterResolverService
                }
              },
              {
                path: 'users',
                component: UsersComponent
              },
              {
                path: 'tv-login',
                component: TvLoginComponent
              },
              {
                path: 'deposit/:crossID',
                component: DepositComponent,
                runGuardsAndResolvers: 'always',
                resolve: {
                  depositData: DepositResolverService
                }
              },
              {
                path: 'domains',
                component: DomainsComponent,
                /*runGuardsAndResolvers: 'always',
                resolve: {
                  depositData: DepositResolverService
                }*/
              },
              {
                path: 'kvkk',
                component: KvkkComponent,
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'parameter'
              }
            ]
          },
          {
            path: 'agencies',
            component: OrganizationListComponent,
            data: {
              viewType: 'AGENCY'
            }
          },
          {
            path: 'agencies/new',
            component: AgencyAddComponent
          },
          {
            path: 'agencies/:id',
            component: OrganizationDetailComponent,
            resolve: {
              organizationData: OrganizationResolverService,
              organizationAgencyData: OrganizationAgencyResolverService,
            },
            data: {
              viewType: 'AGENCY'
            },
            children: [
              {
                path: 'providers',
                component: AgencyProvidersComponent,
                resolve: {
                  providers: ProviderResolverService
                }
              },
              {
                path: 'parameters',
                component: OrganizationParameterComponent,
                resolve: {organizationParameters: ParameterResolverService},
                data: {isAgency: true}
              },
              {
                path: 'credit-cards',
                component: CreditCardComponent
              },
              {
                path: 'domains',
                component: DomainsComponent,
                /*runGuardsAndResolvers: 'always',
                resolve: {
                  depositData: DepositResolverService
                }*/
              },
              {
                path: 'parent-agency',
                component: ParentAgencyComponent,
                resolve: {
                  organizationData: OrganizationResolverService,
                  organizationAgencyData: OrganizationAgencyResolverService,
                },
                runGuardsAndResolvers: 'always'
              },
              {
                path: 'tv-login',
                component: TvLoginComponent
              },
              {
                path: 'users',
                component: UsersComponent
              },
              {
                path: 'kvkk',
                component: KvkkComponent,
                data: {isAgency: true}
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'parameter'
              }
            ]
          },
          {
            path: 'bin-numbers',
            component: BankBinNumbersComponent,
          },
          {
            path: '',
            redirectTo: 'organizations',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'provider-characteristic',
        component: ProviderCharacteristicComponent,
        canActivate: [UserRoleGuardService],
        canActivateChild: [UserRoleGuardService],
        runGuardsAndResolvers: 'always',
        resolve: {
          data: ProviderCharacteristicResolverService
        },
        data: {
          allowedRoles: ['Admin', 'SystemDataManager']
        },
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'system-hotels',
        component: SystemHotelsComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
      },
      {
        path: 'system-hotel-requests',
        component: SystemHotelRequestsComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
      },
      {
        path: 'system-hotel-requests/:id',
        component: HotelDetailComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
      },
      {
        path: 'hotel-register',
        component: HotelRegisterRequestsComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
        data: {
          viewType: 'ORGANIZATION',
        }
      },
      {
        path: 'free-hotel-changes',
        component: FreeHotelChangesComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
        data: {
          viewType: 'ORGANIZATION',
        }
      },
      {
        path: 'free-hotel-changes/:hotelId',
        component: HotelChangesItemComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
        data: {
          viewType: 'ORGANIZATION',
        }
      },
      {
        path: 'room-changes',
        component: RoomChangesComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
        data: {
          viewType: 'ORGANIZATION',
        }
      },
      {
        path: 'image-changes',
        component: ImageChangesComponent,
        canActivate: [AuthUserGuardService],
        canActivateChild: [AuthUserGuardService],
        data: {
          viewType: 'ORGANIZATION',
        }
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '**',
    redirectTo: 'organizations'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/app-routing-module.ts